import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/globals.css';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
      if ('caches' in window) {
        caches.keys().then(keys => keys.forEach(key => caches.delete(key)));
      }
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        for (const registration of registrations) {
          registration.unregister().then(() => {
            console.log('Cleared active ServiceWorker for local dev');
          });
        }
      });
    } else {
      // Self-healing check: purge any old/conflicting service workers
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        for (const r of registrations) {
          const scriptURL = r.active?.scriptURL || '';
          if (scriptURL && !scriptURL.includes('OneSignalSDKWorker.js')) {
            r.unregister().then(() => console.log('Purged old conflicting SW:', scriptURL));
          }
        }
      }).catch(() => {});

      navigator.serviceWorker.register(window.location.origin + '/OneSignalSDKWorker.js')
        .then((registration) => {
          console.log('ServiceWorker registered successfully with scope: ', registration.scope);
          registration.update().catch(err => console.log('SW update failed:', err));
        })
        .catch((err) => {
          console.error('ServiceWorker registration failed: ', err);
        });
    }
  });
}
